// Typing this into either search box opens the statistics page. It is a hidden
// corner of the portal, not a secured one - the page itself is public.
const SECRET_QUERY = 'admin';

export const ADMIN_PATH = '/admin';

// Searching is not implemented at all; revealing the stats page is the only
// thing the search boxes do. Called on every keystroke.
export const openSecretPage = (value, history) => {
    if (value.trim().toLowerCase() !== SECRET_QUERY) {
        return;
    }

    if (history.location.pathname === ADMIN_PATH) {
        return;
    }

    history.push(ADMIN_PATH);
}
